/* ---- Core ---- */
import { computed, reactive, ref, watch } from 'vue';
import useVuelidate from '@vuelidate/core';

/* ---- Models ---- */
import { AuthValidateRules, optionalRule } from '@/models/AuthValidateRules';
import { sameAs } from '@vuelidate/validators';

export function useAuthForm(): unknown {
  /* ---- State ---- */
  const clientId = ref('');
  const authForm = reactive({
    phoneNumber: '',
    checkbox1: false,
    checkbox2: false,
  });
  const rules = computed(() => {
    const updatedRules = { ...AuthValidateRules };

    if (clientId.value === 'LoanApplicationLanding') {
      updatedRules.checkbox1 = {
        required: optionalRule,
        sameAsTrue: sameAs(false),
      };
      updatedRules.checkbox2 = {
        required: optionalRule,
        sameAsTrue: sameAs(false),
      };
    }

    return updatedRules;
  });
  const v$ = useVuelidate(rules, authForm);
  const isAuthFormCompleted = ref(false);
  const clearPhoneNumber = ref('');

  /* ---- Watchers ---- */
  watch(
    [
      () => authForm.phoneNumber,
      () => authForm.checkbox1,
      () => authForm.checkbox2,
    ],
    async ([newPhoneNumber]) => {
      isAuthFormCompleted.value = await v$.value.$validate();
      clearPhoneNumber.value = newPhoneNumber
        .replaceAll(' ', '')
        .replace('+', '');
    }
  );

  watch(
    () => isAuthFormCompleted.value,
    async () => {
      isAuthFormCompleted.value = await v$.value.$validate();
    }
  );

  /* ---- return reactive value of composable ---- */
  return {
    clientId,
    authForm,
    isAuthFormCompleted,
    clearPhoneNumber,
    v$,
  };
}
